import { createSlice } from "@reduxjs/toolkit";
import * as Actions from "../actions";
import { dataCamposDetalheReducer } from "../reducers";
import { InitialStateCamposDetalhe } from "./model";

const initialState: InitialStateCamposDetalhe = {
  items: [],
  dialogForm: {
    open: false,
    content: {
      mode: "",
      values: null,
    },
  },
  requestGetParams: {},
  pagination: {
    page: 1,
    rowsPerPage: 15,
    totalPages: 0,
    totalItems: 0,
  },
};

const camposDetalheSlice = createSlice({
  name: "matrizConfigApp/camposDetalhe",
  initialState,
  reducers: {
    openDialogForm: (state, action) => {
      state.dialogForm = {
        open: true,
        content: action.payload,
      };
    },
    closeDialogForm: (state) => {
      state.dialogForm = {
        open: false,
        content: {
          mode: "",
          values: null,
        },
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(Actions.getCampos.fulfilled, dataCamposDetalheReducer);
  },
});

export const { openDialogForm, closeDialogForm } = camposDetalheSlice.actions;

export default camposDetalheSlice.reducer;
